<template>
    <div class="variant-data" :class="{ 'no-features': !hasFeatures }">
        <h4 v-if="hotelTitle" class="title">{{ hotelTitle }}</h4>
        <div class="features" :class="{ inline }">
            <template v-if="hasFeatures">
                <span v-if="inline"
                    >{{
                        isDirectBooking
                            ? $t('Checkout.variantData.tripAppliesTo')
                            : $t('Checkout.variantData.voucherAppliesTo')
                    }}&nbsp;</span
                >
                <span v-if="variantData.duration" class="feature">{{ variantData.duration }}</span>
                <span v-if="variantData.persons" class="feature">{{ variantData.persons }}</span>
                <span v-if="variantData.roomType" class="feature">{{ variantData.roomType }}</span>
                <span v-if="variantData.catering" class="feature">{{ variantData.catering }}</span>
                <span v-if="variantData.additionalFeature" class="feature">{{ variantData.additionalFeature }}</span>
            </template>

            <a v-if="modalAllowed" href="#" @click.prevent="showHotelModal = true">
                <translate v-if="hasFeatures" path="Checkout.variantData.andMore" />
                <translate v-else path="Checkout.variantData.productInfo" />
            </a>
        </div>

        <Modal v-if="showHotelModal && modalAllowed" :width="800" @close="showHotelModal = false" close-on-escape>
            <div class="hotel-title">
                <Classification
                    v-if="variantData.hotelData.classification"
                    :hotelClassification="variantData.hotelData.classification"
                    class="mt-0"
                />
                <span>{{ variantData.hotelData.name }}</span>
                <span>, {{ variantData.hotelData.region }}</span>
            </div>

            <h5 class="my-3">
                <strong>{{ $t('Checkout.variantData.lookForwardTo') }}</strong>
            </h5>

            <CheckList :items="variantData.services" />
        </Modal>
    </div>
</template>

<script>
import Modal from '@/components/Modal';
import Classification from '@/components/Classification';
import CheckList from '@/components/product/CheckList';

export default {
    name: 'VariantData',
    components: {
        Modal,
        Classification,
        CheckList
    },
    data() {
        return {
            showHotelModal: false
        };
    },
    props: {
        variantData: Object,
        modalAllowed: Boolean,
        isDirectBooking: Boolean,
        inline: Boolean
    },
    computed: {
        hotelTitle() {
            return this.$getSafe(this.variantData, 'hotelData.name');
        },
        hasFeatures() {
            return (
                this.variantData.duration ||
                this.variantData.persons ||
                this.variantData.roomType ||
                this.variantData.catering
            );
        }
    }
};
</script>

<style scoped lang="scss">
@use '@/styles/variables';
@use '@/styles/bootstrap/breakpoints' as breakpoints;

.variant-data {
    font-size: 14px;

    .title {
        font-size: 1em;
        margin-bottom: 0.5rem;
        font-weight: 700;
    }

    &.no-features {
        align-self: flex-end;
        margin-left: auto;
    }

    .features {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        flex-direction: column;
        line-height: 1.2;

        &.inline {
            flex-direction: row;
            font-size: 1em;
            color: variables.$muted;

            span.feature {
                &:after {
                    content: ', ';
                    white-space: pre;
                }

                &:last-of-type:after {
                    content: ' ';
                    white-space: pre;
                }
            }
        }

        @include breakpoints.media-breakpoint-down(variables.$mobile-breakpoint-max) {
            flex-direction: row;

            span.feature {
                &:after {
                    content: ', ';
                    white-space: pre;
                }

                &:last-of-type:after {
                    content: ' ';
                    white-space: pre;
                }
            }
        }

        @include variables.ie {
            &.inline {
                display: block;

                > * {
                    display: inline-block;
                }
            }
        }
    }
}

.hotel-title {
    font-size: 20px;
    display: flex;
    flex-wrap: wrap;
}
</style>
